import StudyListArea from "./study_list";

function SectionListArea(props: any) {
  let myProps = {
    Style:{},
    study_use_info: null,
    open_word_group_result_popup: (inData:any) => {},
    ...props
  };
  let Style=myProps.Style;
  let study_use_info=myProps.study_use_info;
  let section_arr:any=[];
  if(study_use_info&&study_use_info["section_arr"]){
    section_arr=study_use_info["section_arr"];
  }

  const section_list_tags=()=>{
    let section_tags:any=section_arr.map((item:any,idx:number)=>{
      return (
        <div key={idx}>
          <div className={Style.section_title}>
            {item["a_title"]}
          </div>
          <StudyListArea
            Style={Style}
            study_use_info={study_use_info}
            section_seq={item["a_seq"]}
            open_word_group_result_popup={myProps.open_word_group_result_popup}
          ></StudyListArea>
        </div>
      );
    });

    return section_tags;
  };

  return (
    <div className={Style.section_list_wrap}>
      {section_list_tags()}
    </div>
  );
};
export default SectionListArea;